(function($) {

/* フェードアップアニメーション
---------------------------------------------------------------------------- */

$(window).on('load scroll',function (){
	$('.fade-box-up').each(function(){
		var target = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var height = $(window).height();
		if (scroll > target - height){
			$(this).delay(300).queue(function(){
				$(this).addClass('fadeUp');
			})
		}
	});
});

$(window).on('load scroll',function (){
	$('.fade-box-down').each(function(){
		var target = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var height = $(window).height();
		if (scroll > target - height){
			$(this).delay(300).queue(function(){
				$(this).addClass('fadeDown');
			})
		}
	});
});

jQuery(function() {
	jQuery('.effect_fadein').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
	if(isInView){
	jQuery(this).stop().addClass('effect_def');
	}
	else{
	jQuery(this).stop().removeClass('effect_def');
	}
	});
	});

/* アンカーリンク
---------------------------------------------------------------------------- */

$(document).ready(function() {
    $('a[href^="#"]').on('click', function(event) {
        event.preventDefault();
        var target = $($.attr(this, 'href'));
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 800); 
        }
    });
});


/* アコーディオン
---------------------------------------------------------------------------- */

$('.js-acd').click(function(){
	$(this).next('').slideToggle();
	$(this).toggleClass('is-active');
});

/* バナー表示
---------------------------------------------------------------------------- */

$(document).ready(function() {
    var delaySeconds = 3600; // 1時間 = 3600秒
    var popup = $(".bnr");
    var closeBtn = $(".bnr .close");

    function checkPopupDisplay() {
        var now = new Date().getTime();
        var lastClosedTime = localStorage.getItem("bannerClosed");

        if (lastClosedTime) {
            var closedTime = parseInt(lastClosedTime, 10);
            var diffSeconds = Math.ceil((now - closedTime) / 1000);

            if (diffSeconds < delaySeconds) {
                popup.hide(); // 指定時間未満なら非表示
            } else {
                popup.show(); // 指定時間を超えたら表示
            }
        } else {
            popup.show(); // 初回は表示
        }
    }

    closeBtn.click(function() {
        popup.hide();
        var now = new Date().getTime();
        localStorage.setItem("bannerClosed", now); // 現在の時間を保存
    });

    // 初期チェック
    checkPopupDisplay();
});


})(jQuery);
